<!-- Clean, intentional design with only 2,4,8 spacing -->
<div class="min-h-screen bg-gradient-to-br from-brand-briefcream to-brand-nude p-4">
  <div class="max-w-6xl mx-auto">


    <!-- Contact & Participation Cards -->
    <div class="flex flex-col gap-8">

      <!-- Kontakt Card -->
      <!-- Minimal contact card: witnesses left, couple right. No icons. -->
      <info-card [reversed]="true">
        <div card-header>
          <h3 class="font-[Parisienne] text-4xl text-brand-inktint mb-2">Kontakt</h3>
          <p class="font-[Neuton] text-xl text-brand-goldline mb-4">
            Für Fragen, Fahrgemeinschaften oder Beiträge schreibt uns gern eine E-Mail.
          </p>
        </div>

        <!-- LEFT: Witnesses -->
        <div card-content>
          <h4 class="font-semibold text-brand-inktint mb-3">Trauzeugen</h4>
          <ul class="space-y-2 text-brand-inktint/80">
            <li>
              <span class="font-medium text-brand-inktint">Kristina Vogler</span>
              — <a href="mailto:kristina.vogler@outlook.de"
                class="text-brand-goldline hover:underline">kristina.vogler@outlook.de</a>
            </li>
            <li>
              <span class="font-medium text-brand-inktint">Lukas Jakubczyk</span>
              — <a href="mailto:lukas.jakubczyk@thga.de"
                class="text-brand-goldline hover:underline">lukas.jakubczyk@thga.de</a>
            </li>
          </ul>
        </div>

        <!-- RIGHT: Couple -->
        <div card-sidebar>
          <h4 class="font-[Neuton] font-semibold text-brand-inktint mb-3 text-lg">Wir</h4>
          <ul class="space-y-2 text-brand-inktint/80">
            <li>
              <span class="font-medium text-brand-inktint">Tabea Röthemeyer</span>
              — <a href="mailto:tabearoethe@gmail.com"
                class="text-brand-goldline hover:underline">tabearoethe@gmail.com</a>
            </li>
            <li>
              <span class="font-medium text-brand-inktint">Stephan Bökelmann</span>
              — <a href="mailto:stephan.boekelmann@gruppe.ai"
                class="text-brand-goldline hover:underline">stephan.boekelmann@gruppe.ai</a>
            </li>
          </ul>
        </div>
      </info-card>

      <!-- Beteiligung Card (zusammengefasst, freundlich, klar) -->
      <info-card [reversed]="false">
        <div card-header>
          <h3 class="font-[Parisienne] text-4xl text-brand-inktint mb-2">Beteiligungsmöglichkeiten</h3>
          <p class="font-[Neuton] text-xl text-brand-goldline mb-4">Hier ein paar Hinweise, wie ihr die Feier mit uns
            gestalten könnt</p>
        </div>

        <!-- LEFT: Optionen -->
        <div card-content>
          <h4 class="font-[Neuton] font-semibold text-brand-inktint mb-3 text-lg">Zur Planung</h4>
          <p class="text-brand-inktint/80">
            Meldet euch am besten, sobald ihr eine Idee habt, damit wir alles gut koordinieren können. Wir freuen uns
            auf eure
            Beiträge!
          </p>
        </div>

        <!-- RIGHT: Rückmeldung -->
        <div card-sidebar>

          <p class="text-brand-inktint/80 mb-4">
            Eine unvollständige Liste von Beiträgen, über die wir uns freuen:
          </p>
          <ul class="ml-4 space-y-2 text-brand-inktint/80 list-disc marker:text-brand-goldline">
            <li>Mitwirken im Gottesdienst (Musik, Fürbitten)</li>
            <li>Beschäftigungsmöglichkeiten für die Kinder</li>
            <li>Eine Rede</li>
            <li>Essen oder Getränke</li>
            <li>Hilfe beim Aufbau</li>
          </ul>
          <p class="text-sm text-brand-inktint/60 mt-4">
            Bitte plant keine Spiele für uns als Paar oder die gesamte Hochzeitsgesellschaft.
          </p>
        </div>

      </info-card>

    </div>

    <!-- Action Cards: Vertical stack with full width and gap-12 -->
    <footer class="mt-8">
      <div class="flex flex-col gap-12">
        @for (actionCard of actionCards(); track actionCard.title; let i = $index) {
        <action-card [data]="actionCard" [variant]="$even ? 'primary' : 'secondary'">
        </action-card>
        }
      </div>
    </footer>

  </div>
</div>